import WidgetHeader from 'components/TasksV2/UI/WidgetHeader'
import { WidgetWrapper } from 'components/TasksV2/UI/WidgetWrapper'
import React, { memo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Divider, Flex, Text } from '@chakra-ui/core'
import { LinkTitle } from './LinkTitle'
import { LinkPath } from './LinkPath'
import { useWidgetErrorMessage } from '../../useWidgetErrorMessage'
import { WidgetProps } from '../types'
import colors from 'constants/colors'
import useLocaleText from 'components/useLocaleText'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import { isExternalLink } from 'components/TasksV2/TasksOverview/utils'
import { WidgetIsRequiredSwitch } from '../WidgetIsRequiredSwitch'

const LinkWidget: React.FC<WidgetProps> = memo(({ index, isDragging, field, remove, subtaskPath }) => {
  const { control, errors, watch } = useFormContext()
  const t_update_st_link_on_click = useLocaleText('update_st_link_on_click')

  const titleName = `${subtaskPath}.title`
  const pathName = `${subtaskPath}.external_link`

  const linkError = useWidgetErrorMessage({ errors, index, field })

  const link = watch(pathName)
  const isSpecialLink = !!link && isExternalLink(link)

  return (
    <WidgetWrapper pos="relative" p="10px" isDragging={isDragging} isError={!!linkError} errorMessage={linkError}>
      <WidgetHeader onRemove={remove} subtaskType={field.type} />

      <Box mt="25px" mb="15px" border="2px solid #f0f0f0" borderRadius="10px" style={{ rowGap: '10px' }} p="10px">
        <LinkTitle titleName={titleName} field={field} />
        <Divider my={0} />
        <LinkPath pathName={pathName} titleName={titleName} field={field} />
      </Box>

      <Flex
        display={isSpecialLink ? 'flex' : 'none'}
        alignItems="center"
        style={{ columnGap: '10px' }}
        mb="5px"
        justifyContent="flex-end"
        transition={'all 0.3s ease'}
      >
        <Text fontSize="12px" color={colors.analyticGrey}>
          {t_update_st_link_on_click}
        </Text>
        <Controller
          name={`${subtaskPath}.is_external_status_update`}
          control={control}
          defaultValue={true}
          valueName="isChecked"
          onChange={([event]) => !event.target.checked}
          as={({ isChecked, ...rest }) => <ControlledCustomSwitch {...rest} isChecked={!isChecked} />}
        />
      </Flex>
      <WidgetIsRequiredSwitch subtaskPath={subtaskPath} />

      {/*Register constant values in the form context*/}
      <Controller
        name={`${subtaskPath}.type`}
        control={control}
        as={<Box />}
        key={`${subtaskPath}.type`}
        defaultValue={field?.type}
      />
    </WidgetWrapper>
  )
})

export default LinkWidget
